import graphqlClient from "../../../apollo";

class QrProvider {

    qrOrder() {
        return graphqlClient.query({
            query: require('./gql/Qr/qrOrder.graphql'),
            fetchPolicy: "network-only",
        })
    }


    qrHome() {
        return graphqlClient.query({
            query: require('./gql/Qr/qrHome.graphql'),
            fetchPolicy: "network-only",
        })
    }


}

export default new QrProvider()


